export const LabelServicesCalendlyLink =
  "https://calendly.com/business-strmmusic/meet-with-the-strm-team";
